import { useEffect } from "react";
import AfterOnboardAPI from "../../services/AfterOnboardAPI";
import { handleShowContextualLoader } from "../../utils/contextualLoaderTrigger";
import { useDispatch } from "react-redux";
import { setStepperDisable } from "../../redux/slices/userSlice";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

export default function SelfieHyperverge() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { selfieHyperverge } = new AfterOnboardAPI();

  const startHyperverge = async () => {
    try {
      handleShowContextualLoader("Start your Selfie...");
      const response = await selfieHyperverge();
      if (response?.data?.status === "failure") {
        navigate("/dashboard");
        return;
      }
      await new Promise((res) => setTimeout(res, 3000));
      const redirectUrl = response?.data?.startKycUrl;
      dispatch(setStepperDisable(true));
      if (window.parent) {
        window.parent.location.href = redirectUrl;
      } else if (redirectUrl) {
        window.location.href = redirectUrl;
      }
    } catch (error) {
      console.error("Error starting Hyperverge result:", error);
      Swal.fire({
        icon: "error",
        text: "Something went wrong",
      });
      navigate("/dashboard");
    }
  };

  useEffect(() => {
    startHyperverge();
  }, []);

  return null;
}
